<template>
  <div class="container">
    <div class="aboutImg">
      <img src="static/img/aboutUs.jpg">
    </div>
    <div class="introduce_firstLine">
      {{this.$store.state.language.a}}
    </div>      
    <div class="introduce_SecondLine">
      {{this.$store.state.language.b}}
    </div>
    <div class="introduce_TrirdLine">
      {{this.$store.state.language.c}}
    </div>
    <div class="introduce_fourthLine">
      {{this.$store.state.language.d}}
    </div>
    <div class="introduce_fifthLine">
      {{this.$store.state.language.e}}
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>
<style scoped>
.content{
  position: relative!important;
}
.container{
  box-sizing: border-box;
  border-top: 1px solid white
}
.introduce_firstLine,.introduce_SecondLine,.introduce_TrirdLine,.introduce_fourthLine,.introduce_fifthLine{
  width: 70%;
  font-size: 1.2rem;
  margin: 0 auto;
}
.introduce_firstLine{
  margin-top: 5rem
}
.introduce_SecondLine{
  margin-top: 1rem;
}
.introduce_TrirdLine{
  margin-top: 1rem;
}
.introduce_fourthLine{
  margin-top: 1rem;
}
.introduce_fifthLine{
  margin-top: 1rem;
  margin-bottom: 4rem;
}
.aboutImg{
  width: 100%;
  height: 30rem;
}
.aboutImg img{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutNaselit.vue